import {X} from 'lucide-react'
import {cn} from '@/lib/utils'

interface SearchClearButtonProps {
    onClick: () => void
    iconClassName?: string
    'aria-label'?: string
    'data-testid'?: string
}

export function SearchClearButton({
    onClick,
    iconClassName,
    'aria-label': ariaLabel,
    'data-testid': testId,
}: SearchClearButtonProps) {
    return (
        <button
            data-testid={testId}
            type="button"
            onClick={onClick}
            className="absolute right-2 top-2.5 text-muted-foreground hover:text-foreground"
            aria-label={ariaLabel}
        >
            <X className={cn('h-4 w-4', iconClassName)}/>
        </button>
    )
}
